import { render, staticRenderFns } from "./USStockQA.vue?vue&type=template&id=1db79dc0&scoped=true"
import script from "./USStockQA.vue?vue&type=script&lang=js"
export * from "./USStockQA.vue?vue&type=script&lang=js"
import style0 from "./USStockQA.vue?vue&type=style&index=0&id=1db79dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db79dc0",
  null
  
)

export default component.exports